import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { ContactDepartmentService } from 'application/contact-department/services';
import { FacilityService } from 'application/facility/services';
import { action } from 'mobx';
import _ from 'lodash';

class FacilityAdditionalContactSearchModalViewStore extends BaseViewStore {
    constructor(rootStore, componentParams) {
        super(rootStore);

        this.rootStore = rootStore;
        this.componentParams = componentParams;
        this.modalParams = componentParams.modalParams;
        this.parameters = this.modalParams.data.parameters;

        this.service = new FacilityService(rootStore.application.baasic.apiClient);
        this.contactDepartmentService = new ContactDepartmentService(rootStore.application.baasic.apiClient);

        this.contactDepartmentStore = new BaasicDropdownStore({ multi: true, filterable: true }, {
            fetchFunc: async (term) => {
                const response = await this.contactDepartmentService.find({ searchQuery: term, rpp: 50 });
                return response.data.item;
            },
        });
    }

    @action.bound
    async downloadContactsReport() {
        let params = {...this.parameters};
        if(this.contactDepartmentStore.value && this.contactDepartmentStore.value.length > 0){
            params = _.extend(params, {
                contactDepartmentIds: this.contactDepartmentStore.value.map(i => {return i.id})
            });
        }

        this.downloadContactsUrl = this.service.getDownloadContactsUrl(params);
        window.open(
                    `${this.downloadContactsUrl}&contentDisposition=attachment&token=${
                        this.rootStore.authStore.token.tokenUrl
                    }&ttype=${
                        this.rootStore.authStore.token.type}`
                );
    }
}

export default FacilityAdditionalContactSearchModalViewStore;